import styled from 'styled-components/macro';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
